// PROTOTYPE — raw takeoff export for Job 2918 (MATTAWAN MIDDLE SCHOOL – ADDITIONS & RENOVATIONS).
// Shape mirrors a typical On-Screen Takeoff / Bluebeam CSV: section header rows
// followed by item rows. Real API: the parse job reads the job's attached file.

export const TAKEOFF_FILE = {
  name: "2918_Mattawan_MS_Painting_Takeoff_Rev2.xlsx",
  sizeKb: 486,
  uploadedBy: "Chotu Lal Sharma",
  uploadedAt: "2026-10-16T14:22:00Z",
};

const A10 = "Unit A / Second Floor / Building 10";
const A11 = "Unit A / First Floor / Building 10";
const B = "Unit B / First Floor / Gymnasium";
const C = "Unit C / First Floor / Classroom Wing";
const D = "Unit D / Second Floor / Media Center";
const EXT = "Exterior / Building 10 Addition";

// [section, rawName, location, qty, unit]
const ROWS = [
  ["wall", `CMU Wall (h=3'0"), Epoxy Paint PCE-1`, A10, 51.66, "SQ FT"],
  ["wall", `CMU Wall (h=3'0"), Paint P-4`, A10, 51.84, "SQ FT"],
  ["wall", `CMU Wall (h=8'6"), Paint P-1`, A10, 559.55, "SQ FT"],
  ["wall", `CMU Wall (h=8'6"), Paint P-1`, A11, 1093.53, "SQ FT"],
  ["wall", `CMU Wall (h=8'6"), Paint P-4`, A11, 104.38, "SQ FT"],
  ["wall", `CMU Wall (h=8'8"), Paint P-1`, C, 1456.35, "SQ FT"],
  ["wall", `CMU Wall (h=9'0"), Epoxy Paint PCE-1`, A11, 2925, "SQ FT"],
  ["wall", `CMU Wall (h=9'0"), Epoxy Paint PCE-3`, A11, 414.36, "SQ FT"],
  ["wall", `CMU Wall (h=9'0"), Epoxy Paint PCE-5`, C, 316.62, "SQ FT"],
  ["wall", `CMU Wall (h=9'0"), Paint P-1`, C, 4994.82, "SQ FT"],
  ["wall", `CMU Wall (h=10'0"), Paint P-1`, D, 373.8, "SQ FT"],
  ["wall", `CMU Wall (h=11'0"), Paint P-1`, D, 196.46, "SQ FT"],
  ["wall", `CMU Wall (h=11'0"), Paint P-4`, D, 623.26, "SQ FT"],
  ["wall", `CMU Wall (h=12'0"), Epoxy Paint PCE-1`, A11, 1012.08, "SQ FT"],
  ["wall", `CMU Wall (h=12'0"), Paint P-1`, C, 259.8, "SQ FT"],
  ["wall", `CMU Wall (h=14'0"), Paint P-1`, B, 2210.4, "SQ FT"],
  ["wall", `CMU Wall (h=16'0"), Paint P-1`, B, 1840, "SQ FT"],
  ["wall", `CMU Wall (h=20'0"), Paint P-1`, B, 3120.75, "SQ FT"],
  ["wall", `Gyp Wall (h=9'0"), Paint P-1`, C, 3480.2, "SQ FT"],
  ["wall", `Gyp Wall (h=9'0"), Paint P-2`, D, 1260.5, "SQ FT"],
  ["wall", `Gyp Wall (h=10'0"), Paint P-1`, D, 2215, "SQ FT"],
  ["wall", `Gyp Wall (h=12'0"), Paint P-3`, A11, 640, "SQ FT"],
  ["wall", `Gyp Wall (h=9'0"), Epoxy Paint PCE-2`, A10, 820.4, "SQ FT"],
  ["wall", `Gyp Wall (h=8'0"), Paint P-1`, A10, 990, "SQ FT"],
  ["wall", `Gyp Wall Level 5 (h=10'0"), Paint P-3`, A11, 445, "SQ FT"],
  ["wall", `Gyp Wall (h=9'0"), Paint P-1`, C, null, "SQ FT"],

  ["ceiling", `Gyp Ceiling (h=9'0"), Paint P-5`, C, 2840, "SQ FT"],
  ["ceiling", `Gyp Ceiling (h=10'0"), Paint P-5`, D, 1120.6, "SQ FT"],
  ["ceiling", `Gyp Soffit (h=12'0"), Paint P-5`, A11, 360.2, "SQ FT"],
  ["ceiling", `Gyp Ceiling (h=9'0"), Epoxy Paint PCE-2`, A10, 410, "SQ FT"],
  ["ceiling", `ACT Ceiling 2x4 + Grid (h=9'0"), Paint P-5`, C, 5200, "SQ FT"],
  ["ceiling", `ACT Ceiling 2x2 + Grid (h=10'0"), Paint P-5`, D, 2850, "SQ FT"],
  ["ceiling", `Exposed Structure / Deck (h=22'0"), Dry Fall DF-1`, A11, 6400, "SQ FT"],
  ["ceiling", `Exposed Structure / Deck (h=32'0"), Dry Fall DF-1`, B, 9200, "SQ FT"],
  ["ceiling", `Textured Ceiling (h=9'0"), Paint P-5`, D, 380, "SQ FT"],
  ["ceiling", `Open Deck Steel Joists (h=18'0"), Dry Fall DF-1`, A11, 2100, "SQ FT"],

  ["door", `HM Door 3'0"x7'0", Paint P-6`, "All Units", 48, "EA"],
  ["door", `HM Frame 3'0"x7'0", Paint P-6`, "All Units", 52, "EA"],
  ["door", `HM Door Pair 6'0"x7'0", Paint P-6`, "All Units", 8, "EA"],
  ["door", `HM Frame Pair 6'0"x7'0", Paint P-6`, "All Units", 9, "EA"],
  ["door", `Wood Door 3'0"x7'0", Paint P-6`, D, 12, "EA"],
  ["door", `Wood Frame w/ Casing, Paint P-6`, D, 6, "EA"],
  ["door", `HM Borrowed Lite Frame, Paint P-6`, C, 4, "EA"],
  ["door", `Access Panel 24"x24"`, "All Units", 12, "EA"],
  ["door", `Overhead Coiling Door 10'x10'`, B, 2, "EA"],
  ["door", `Wood Door 3'0"x7'0", Paint P-6`, C, null, "EA"],

  ["trim", `Wood Base 1x6, Paint P-6`, D, 820, "LN FT"],
  ["trim", `Wood Window Stool, Paint P-6`, C, 140, "LN FT"],
  ["trim", `Wood Chair Rail, Paint P-6`, D, 260, "LN FT"],
  ["trim", `Steel Handrail 1-1/2" Pipe Rail, Paint P-4`, "Stairs 1 & 2", 310, "LN FT"],
  ["trim", `Steel Guardrail, Paint P-4`, "Stairs 1 & 2", 85, "LN FT"],
  ["trim", `Steel Lintel L4x4`, "All Units", 46, "LN FT"],
  ["trim", `Casework Toe Kick, Paint P-6`, C, 28, "LN FT"],

  ["misc", `Steel Column HSS 6x6 (h=14'0")`, B, 22, "EA"],
  ["misc", `Pipe Bollard 6" dia.`, EXT, 8, "EA"],
  ["misc", `Gas Piping (exposed)`, A11, 140, "LN FT"],
  ["misc", `Exposed Ductwork (spiral)`, B, 620, "LN FT"],
  ["misc", `Electrical Conduit (exposed)`, B, 900, "LN FT"],
  ["misc", `Fire Extinguisher Cabinet`, "All Units", 14, "EA"],
  ["misc", `Wall Louver 24"x36"`, A11, 6, "EA"],
  ["misc", `Expansion Joint Cover`, "All Units", 120, "LN FT"],
  ["misc", `Roof Hatch Interior Frame`, A10, 1, "EA"],

  ["exterior", `Hardie Lap Siding (h=24'0"), Paint EXT-1`, EXT, 4860, "SQ FT"],
  ["exterior", `Hardie Panel Siding (h=14'0"), Paint EXT-1`, EXT, 1320, "SQ FT"],
  ["exterior", `Hardie Trim 1x4, Paint EXT-2`, EXT, 1180, "LN FT"],
  ["exterior", `Hardie Soffit (h=24'0"), Paint EXT-2`, EXT, 640, "SQ FT"],
  ["exterior", `HM Exterior Door 3'0"x7'0", Paint EXT-3`, EXT, 6, "EA"],
  ["exterior", `Rooftop Mech. Screen`, EXT, 1, "LS"],
];

export const RAW_TAKEOFF_2918 = ROWS.map(([section, rawName, location, qty, rawUnit], i) => ({
  id: `L${String(i + 1).padStart(3, "0")}`,
  section,
  rawName,
  location,
  qty,
  rawUnit,
}));
